import React from "react";
import { TriangleIcon } from "@icons";
import {
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    AccordionTrigger,
} from "./Accordion";
import styles from "./DetailsAccordionItem.module.scss";

interface DetailsAccordionItemProps {
    value: string;
    label: string;
    /**
     * Horizontal inset of the trigger and panel chrome. `wide` is the roomier
     * variant used by the transactions details panel.
     */
    inset?: "default" | "wide";
    children: React.ReactNode;
}

/**
 * @purpose Collapsible section used by details panels (transactions, bills,
 * invoices): a 64px trigger with a leading caret and a padded panel body.
 * The padding sits inside the panel, whose height animates, so the panel
 * really reaches zero instead of jumping across its padding.
 */
export const DetailsAccordionItem: React.FC<DetailsAccordionItemProps> = ({
    value,
    label,
    inset = "default",
    children,
}) => (
    <AccordionItem
        value={value}
        className={styles.accordionItem}
        data-inset={inset}
    >
        <AccordionHeader>
            <AccordionTrigger className={styles.accordionTrigger}>
                <TriangleIcon className={styles.accordionTriggerIcon} />
                {label}
            </AccordionTrigger>
        </AccordionHeader>
        <AccordionPanel>
            <div className={styles.accordionPanelContent}>{children}</div>
        </AccordionPanel>
    </AccordionItem>
);
